import {readNativeRenderRequest} from './native-render-job';
import type {NativeWorkScope} from './native-envelope';

export type CaptionTranslationRequest={
 requestId:string;scope:NativeWorkScope;expectedRevision:string;
 targetLanguage:'en'|'ko';assetIds:string[];titleIds:string[];
};
const record=(v:unknown):v is Record<string,unknown>=>!!v&&typeof v==='object'&&!Array.isArray(v);
/** Server resolves text from this owned saved work; the client cannot supply prompts, models, or media URLs. */
export function readCaptionTranslationRequest(value:unknown):CaptionTranslationRequest{
 if(!record(value)||Object.keys(value).some(k=>!['requestId','scope','expectedRevision','targetLanguage','assetIds','titleIds'].includes(k))||(value.targetLanguage!=='en'&&value.targetLanguage!=='ko'))throw Error('번역 요청 정보를 확인해 주세요.');
 const base=readNativeRenderRequest({requestId:value.requestId,scope:value.scope,expectedRevision:value.expectedRevision});
 const ids=(raw:unknown)=>{
  if(!Array.isArray(raw)||raw.length>10000||!raw.every(id=>typeof id==='string'&&id.length>0&&id.length<=256&&id.trim()===id&&!/[\u0000-\u001f]/.test(id)&&!['__proto__','constructor','prototype'].includes(id))||new Set(raw).size!==raw.length)throw Error('번역 대상 목록을 확인해 주세요.');
  return [...raw].sort() as string[];
 };
 const assetIds=ids(value.assetIds),titleIds=ids(value.titleIds);
 if(!assetIds.length&&!titleIds.length)throw Error('번역할 자막이나 제목을 선택해 주세요.');
 return {requestId:base.requestId,scope:base.scope,expectedRevision:base.expectedRevision,targetLanguage:value.targetLanguage,assetIds,titleIds};
}
